/* eslint-disable */
import lax from 'lax.js'

// TODO typescript... (probably with Vue 3, because of bad typescript support in vue 2...)

export default {
  install(Vue) {
    Vue.prototype.$lax = lax;
    // initialize scroll listener on initialization once on the root element
    // TODO find a cleaner and more general way to do this...
    let initialized = false;
    let oldInnerWidth = window.innerWidth;
    Vue.mixin({
      mounted() {
        if (!initialized) {
          initialized = true;
          lax.setup(); // necessary, will not do much, as everything is setup dynamically using lax.addElement and lax.removeElement
          this.$root.$el.addEventListener('scroll', () => lax.update(this.$root.$el.scrollTop));
          // make lax responsive
          window.addEventListener('resize', () => {
            const {innerWidth} = window;
            if (oldInnerWidth !== innerWidth) {
              oldInnerWidth = innerWidth;
              lax.updateElements();
            }
          });
        }
      }
    })
  }
}
